import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'

import { boxStyle } from './styles'

type IBoxProps = React.ComponentPropsWithoutRef<'div'> &
    VariantProps<typeof boxStyle> & { className?: string; nativeID?: string }

const Box = React.forwardRef<HTMLDivElement, IBoxProps>(function Box(
    { className, nativeID, id, ...props },
    ref,
) {
    return (
        <div ref={ref} id={id ?? nativeID} className={boxStyle({ class: className })} {...props} />
    )
})

Box.displayName = 'Box'
export { Box }
